import React from 'react';
import { Box } from '../../../design-system';
import LearningTitle from './LearningTitle';
import LearningSubtitle from './LearningSubtitle';

interface LearningContentProps {
  titleFontSize?: { xs: string; md: string };
  titleMaxWidth?: string;
  subtitleFontSize?: { xs: string; md: string };
  subtitleMaxWidth?: string;
}

const LearningContent: React.FC<LearningContentProps> = ({
  titleFontSize,
  titleMaxWidth,
  subtitleFontSize,
  subtitleMaxWidth,
}) => {
  return (
    <Box sx={{ textAlign: 'center', mb: 6 }}>
      <LearningTitle fontSize={titleFontSize} maxWidth={titleMaxWidth} />
      <LearningSubtitle fontSize={subtitleFontSize} maxWidth={subtitleMaxWidth} />
    </Box>
  );
};

export default LearningContent;
